interface IProps {
  width?: number;
  height?: number;
}

export default function Prepare17({ width, height }: IProps) {
  return (
    <img
      className="timeline-layout--svg--icon"
      src="https://media.synctrack.io/megamind-estimated/icon-timeline/prepare17.gif"
      width={width || 30}
      height={height || 30}
      alt="Prepare icon"
    />
  );
}
